import React from "react";

export default function CustomBlock({data}) {
    return (
        <div dangerouslySetInnerHTML={{ __html: data?.field_custom_js[0]?.value }} />
    );
}
